import { useMemo } from 'react';

import { createAbsoluteNumber } from '@app/features/apply-react-signing/components/FieldRenderer/libs/createAbsoluteNumber';
import ptToPx from '@app/libs/unitConverters/ptToPx';

export const FONT_SIZE_POINTS = [
  4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 24, 30, 36, 48, 60,
];

export function useFontPixelSizes(scale: number) {
  return useMemo(
    () => FONT_SIZE_POINTS.map((v) => createAbsoluteNumber(ptToPx(v) * scale)),
    [scale]
  );
}
